/**
 * Builds searchable-select options for provider reassignment.
 * @module reAssignModal/utils/buildProviderSelectOptions
 */

import {
  UNASSIGNED_TEXT,
  UNASSIGNED_TEXT_LABEL,
} from "../../../../constants/stringLiterals";
import { generateFullName } from "../../../../utils/generateOrderDataForTable";
import { ProviderSelectOption, ReassignModalProvider } from "../types";

/**
 * Maps providers to sorted select options with an unassigned entry appended.
 *
 * @param providersDetails - Provider list from Redux
 * @returns Options for {@link SearchableSelect}
 */
export const buildProviderSelectOptions = (
  providersDetails: ReassignModalProvider[] | undefined,
): ProviderSelectOption[] => {
  const providerOptions =
    providersDetails
      ?.map((provider) => ({
        value: provider.id,
        label: generateFullName(
          provider.FirstName || provider.name || "",
          "",
          provider.LastName || "",
        ),
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) ?? [];

  return [
    ...providerOptions,
    {
      value: UNASSIGNED_TEXT,
      label: UNASSIGNED_TEXT_LABEL,
    },
  ];
};
